var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.308-.15C1.228-.15.352.7.352 1.747v22.675c0 1.046.876 1.895 1.956 1.895H24.86c1.08 0 1.956-.849 1.956-1.895V1.745c0-1.046-.876-1.895-1.956-1.895H2.308Zm6.086 10.234v11.915h-3.96V10.084h3.96Zm.26-3.685c0 1.143-.859 2.058-2.24 2.058H6.39C5.059 8.457 4.2 7.542 4.2 6.4c0-1.17.885-2.059 2.24-2.059 1.355 0 2.19.89 2.215 2.06ZM14.547 22h-3.96s.052-10.797 0-11.915h3.96v1.687c.527-.812 1.469-1.966 3.57-1.966 2.605 0 4.558 1.703 4.558 5.362V22h-3.96v-6.374c0-1.602-.573-2.694-2.005-2.694-1.095 0-1.746.737-2.033 1.448-.104.254-.13.611-.13.967v6.653Z",
    fill: "var(--a, #000)"
  })));
};

export default SvgLinkedin;